import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom"

const AITokenUtilization = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="main_title">
                <h1>AI Token Utilization</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Token Utilization
                </p>
            </div>
            <div className="cards ai_token_card">
             
            </div>
        </>
    )
}
export default AITokenUtilization